import { render, staticRenderFns } from "./sidebarLocation.vue?vue&type=template&id=a16528ea&"
import script from "./sidebarLocation.vue?vue&type=script&lang=js&"
export * from "./sidebarLocation.vue?vue&type=script&lang=js&"
import style0 from "./sidebarLocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports